import { useRef } from "react";
import Icon from "../Icon";
import useFocoModal from "../../hooks/useFocoModal";

// Confirmacion al traer muchas paginas de golpe (todos los resultados del filtro, si son mas de 50).
export function ConfirmarMuchas({ n, ocupado, onConfirmar, onCancelar }) {
  const ref = useRef(null);
  useFocoModal(ref, true, onCancelar);
  return (
    <div onClick={onCancelar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }}>
      <div ref={ref} role="alertdialog" aria-modal="true" onClick={e => e.stopPropagation()}
        style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, padding: 16, maxWidth: 440, width: "100%", boxShadow: "var(--shadow-md)" }}>
        <h3 style={{ fontSize: 15, marginBottom: 6, color: "var(--text)" }}>¿Añadir {n} tareas a Mis tareas?</h3>
        <p style={{ fontSize: 13, color: "var(--text2)", marginBottom: 12 }}>
          Vas a traer todos los resultados del filtro actual. Podrás quitarlas una a una más tarde, pero son muchas: revisa que el filtro es el que quieres.
        </p>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
          <button type="button" className="nt-b" onClick={onCancelar}>Cancelar</button>
          <button type="button" className="nt-b p" onClick={onConfirmar} disabled={ocupado}>Sí, añadir {n}</button>
        </div>
      </div>
    </div>
  );
}

// Logo «N» de Notion: origen de una tarea en «Mis tareas» y marca de la vista de Notion.
// Es decorativo: el nombre del origen siempre va en texto al lado.
export function NotionLogo({ title = "Página de Notion" }) {
  return <span className="nt-logo" aria-hidden="true" title={title}>N</span>;
}

// «Ya en Mis tareas» + «Quitar». Quitar no es «hecha»: la tarea desaparece de Mis tareas
// y se puede volver a traer; en Notion no cambia nada.
export function YaEnMisTareas({ page, onQuitar }) {
  return (
    <span className="nt-ya-grupo">
      <span className="nt-ya"><Icon name="check2" size={11} color="currentColor" />Ya en Mis tareas</span>
      <button type="button" className="nt-quitar" onClick={() => onQuitar(page)}
        aria-label={`Quitar «${page.title || "Sin título"}» de Mis tareas`}>Quitar</button>
    </span>
  );
}
